var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { ThemeProvider } from "styled-components";
import { get } from "lodash-es";
import { SideBar, Title, SideBarItem, Container, Text, Card, } from './Elements';
import { CenterBox } from '../../shared/Element';
import * as Icons from '../../shared/icons';
import { doconTheme } from "../../../theme/default";
export var Icon;
(function (Icon) {
    Icon["setting"] = "SettingIcon";
    Icon["delete"] = "DeleteIcon";
    Icon["search"] = "SearchIcon";
    Icon["bell"] = "BellIcon";
    Icon["chat"] = "ChatIcon";
    Icon["home2"] = "Home2Icon";
    Icon["video"] = "VideoIcon";
    Icon["record"] = "RecordIcon";
    Icon["calenderFollowup"] = "CalenderFollowUp";
    Icon["calender"] = "CalenderIcon";
    Icon["help"] = "HelpIcon";
    Icon["cross"] = "CrossIcon";
})(Icon || (Icon = {}));
function getIcon(icon) {
    if (React.isValidElement(icon))
        return icon;
    var IconNode = Icons[Icon[icon]];
    if (IconNode)
        return React.createElement(IconNode, null);
    return null;
}
var NavItem = function (_a) {
    var onClick = _a.onClick, nav = _a.nav, isSelected = _a.isSelected;
    var cardRef = useRef(null);
    var _b = __read(useState(0), 2), extraWidth = _b[0], setExtraWidth = _b[1];
    useEffect(function () {
        var cardWidth = get(cardRef.current, 'offsetWidth') || 0;
        setExtraWidth(cardWidth + 20 + (nav.cardText ? 8 : 0));
    }, []);
    function handleClick() {
        onClick && onClick(nav);
    }
    return (React.createElement(SideBarItem, { onClick: handleClick, "$isSelected": isSelected },
        nav.icon ? (React.createElement(CenterBox, { size: 20 }, getIcon(nav.icon))) : null,
        React.createElement(Text, { as: 'span', pl: nav.icon ? '12px' : 0, "$width": extraWidth }, nav.name),
        nav.cardText ? React.createElement(Card, { ref: cardRef, bg: nav.cardBgColor || '#69cabd' }, nav.cardText) : null));
};
var DoconLeftNavbar = function (_a) {
    var lists = _a.lists, selected = _a.selected, onClick = _a.onClick, props = __rest(_a, ["lists", "selected", "onClick"]);
    return (React.createElement(ThemeProvider, { theme: doconTheme },
        React.createElement(SideBar, __assign({}, props), lists.map(function (list, index) { return (React.createElement(Container, { key: index },
            React.createElement(Title, { fontWeight: "medium", title: list.title }),
            list.navLists.map(function (nav) { return (React.createElement(NavItem, { key: nav.name, isSelected: selected === nav.name, nav: nav, onClick: onClick })); }))); }))));
};
export default DoconLeftNavbar;
